import { getProcess, isBookingProcess } from '../transactions/transaction';

// The process graph handles card, pay-later, custom offers and legacy bookings.
// Payment authorization or host acceptance while awaiting payment is not yet a
// confirmed booking. Keep the location available in its history after confirmation.
export const canShowBookingLocation = transaction => {
  const processName = transaction?.attributes?.processName;
  if (!isBookingProcess(processName)) return false;

  const process = getProcess(processName);
  return process.hasPassedState(process.states.ACCEPTED, transaction);
};
